<template>
    <v-text-field
        ref="textField"
        :value="value"
        :label="label || 'Phone number'"
        data-jestid="phone-number-input"
        :maxlength="14"
        :rules="[phoneNumberRule]"
        @input="onPhoneNumberInput">
        <template
            v-if="isMulti"
            v-slot:append>
            <v-icon
                v-if="idx === 0"
                data-jestid="add-phone-number-icon"
                @click="addField">
                mdi-plus
            </v-icon>
            <v-icon
                v-else
                color="error"
                data-jestid="remove-phone-number-icon"
                @click="removeField">
                mdi-close-thick
            </v-icon>
        </template>
    </v-text-field>
</template>

<script>
import { Utils } from '@/utils';

export default {
    props: {
        addField: Function,
        removeField: Function,
        value: String,
        idx: Number,
        isMulti: Boolean,
        label: String,
        required: Boolean,
    },
    data() {
        return {
            phoneNumberRule: (v) =>
                (!v && !this.required) || /^\(\d{3}\) \d{3}-\d{4}$/.test(v) || 'Phone number is not valid',
        };
    },
    methods: {
        onPhoneNumberInput(value) {
            this.$nextTick(() => {
                let caretPosition = this.$refs.textField.$refs.input.selectionStart;

                const newValue = Utils.formatPhoneNumber(value);

                this.$emit('input', newValue);

                if (value.length === 1 || (value[0] !== '(' && caretPosition !== 0)) {
                    caretPosition += 1;
                } else if (this.value && value.length > this.value.length) {
                    if (value.length === 6 || value.length === 10) {
                        caretPosition += 2;
                    }
                }

                this.$nextTick(() => {
                    this.$refs.textField.$refs.input.setSelectionRange(caretPosition, caretPosition);
                });
            });
        },
    },
};
</script>